import React from 'react'
import Navbarmenu from './Navbarmenu';
import './FaqContent.css';
import Container from '@material-ui/core/Container';

 function FaqContent() {
    return (
        <>
            <div className="main-container" id="faqcontent-box">
                <title>Security Learning - FAQ</title>
                <img src={process.env.PUBLIC_URL +"/images/FAQ.jpg"} className="banner-img"/>
                <Navbarmenu/>
            </div>
            <Container className='faq-container' maxWidth="xl">
                <h2>Coming Soon...</h2>
                <h3>Under Construction</h3>
                <a href="/home">Go to Home</a>
            </Container>
        </>
    )
}
export default FaqContent;